// extracted by mini-css-extract-plugin
export default {"container":"NotifyInternetRecommender-module__container-rdUw2l"};